<template>
  <div id="app">
<pre>
&lt;script type="text/javascript"&gt;
    alert(typeof 12345);	<span>//输出number</span>
    alert(typeof "abc");	<span>//输出string</span>
    alert(typeof document);	<span>//输出object</span>
&lt;/script&gt;
</pre>
  </div>
</template>
<script>
export default {
  created(){
    alert(typeof 12345);
    alert(typeof 'abc');
    alert(typeof document);    
  }
}
</script>
<style>
pre{
  color: green;
  padding: 10px 15px;
  background: #f0f0f0;
  border: 1px dotted #333;
  font: 12px/1.5 courier new;
}
span{
  color: #999;
}
</style>
